import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { TopLevelBlock } from '@contentful/rich-text-types';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import Markdown from 'components/markdown';
import TabsAccordeon from 'components/tabs-accordeon-new';
import renderDocument from 'modules/content-cms/util/render-document';
import Head from 'next/head';
import React from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { FAQPage, Question } from 'schema-dts';
import { ISectionFaQsFaq, ISectionFaQsFields } from '../../../../global';

type FaqSectionProps = ISectionFaQsFields & {
  onClickCallback?: (arg: { faq: ISectionFaQsFaq; index: number }) => void;
};

const FaqSection: React.FC<FaqSectionProps> = ({ faqs, onClickCallback }) => {
  const [openQuestion, setOpenQuestion] = React.useState<null | number>(null);

  const extractAnswer = (answer: TopLevelBlock[]): string => {
    const mappedAnswer: string[] = [];
    answer.forEach((item) => {
      mappedAnswer.push(documentToPlainTextString(item));
    });
    return mappedAnswer.join('');
  };

  const generateFaqMainEntity = (faqs: ISectionFaQsFaq[]): Question[] => {
    const schema: Question[] = [];
    faqs.forEach((item) => {
      schema.push({
        '@type': 'Question',
        name: item.fields.title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: extractAnswer(item.fields.bodyText.content),
        },
      });
    });

    return schema;
  };

  return (
    <>
      <Head>
        <script
          {...jsonLdScriptProps<FAQPage>({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: generateFaqMainEntity(faqs),
          })}
        />
      </Head>
      <LazyMotionWrapper>
        <div>
          {faqs.map((faq, index) => (
            <TabsAccordeon
              key={faq.sys.id}
              id={faq.sys.id}
              index={index}
              isOpen={openQuestion === index}
              onClick={() => {
                setOpenQuestion(openQuestion === index ? null : index);
                onClickCallback &&
                  onClickCallback({
                    faq,
                    index,
                  });
              }}
              title={faq.fields.title}
              content={
                <Markdown>{renderDocument(faq.fields.bodyText)}</Markdown>
              }
            />
          ))}
        </div>
      </LazyMotionWrapper>
    </>
  );
};

export default FaqSection;
